var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex flex-row align-center justify-space-between mb-3"},[_c('BizStartHour'),_c('DaySelector',{on:{"select":_vm.load}})],1),_c('OrderTable',{staticClass:"my-5"}),_c('div',{staticClass:"d-flex flex-row my-5"},[_c('Download',{staticClass:"mr-3"}),_c('OrderPaymentList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }